import { FormControl } from '@angular/forms';

// ==在比较的时候可以转自动换数据类型、===严格比较，不会进行自动转换，要求进行比较的操作数必须类型一致
//手机的校验
export function mobileValidator(control: FormControl): any{
  const mobileReg = /^(\d{2}-)?1[345789]\d{9}$/;
  const phoneReg = /^(0\d{2,3}-)?\d{7,8}$/;
  if(control.value==''||control.value == null){
    return null;
  }
  const mobileRegResult = mobileReg.test(control.value);
  const phoneRegResult = phoneReg.test(control.value);
  return (mobileRegResult||phoneRegResult) ? null : { mobile: true };
}

//邮政编码的校验
export function zipValidator(control: FormControl): any{
  const zipCodeReg = /^[0-9]{6}$/;
  if(control.value===''||control.value == null){
    return null;
  }
  const result = zipCodeReg.test(control.value);
  return result ? null : { zipCode: true };
}
//email的校验
export function emailValidator(control: FormControl): any{
  const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\\w+)*\.\w+([-.]\w+)*$/;
  if(control.value===''||control.value == null){
    return null;
  }
  const result = emailReg.test(control.value);
  return result ? null : { email: true };
}
//数字的校验
export function numberValidator(control: FormControl): any{
  const numberReg = /^[0-9]*$/;
  if(control.value===''||control.value == null){
    return null;
  }
  const result = numberReg.test(control.value);
  return result ? null : { number: true };
}
//identify前缀的校验
export function identifierPrefixValidator(control: FormControl): any{
  const identifierPrefixReg = /^[0-9a-zA-Z_]{1,10}$/;
  if(control.value===''||control.value == null){
    return null;
  }
  const result = identifierPrefixReg.test(control.value);
  return result ? null : { number: true };
}
